import React, { useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  TextField,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { search } from "api/messagesApi";
import { isMappableArray } from "util/helpers";
import withShowAlert from "components/withShowAlert";
import { useParams } from "react-router-dom";

const initialState = {
  topic: undefined,
  status: undefined,
  start_date: undefined,
  end_date: undefined,
  search: undefined,
};

const MessageFilter = ({
  kind,
  filters,
  onSearch,
  loadData,
  setIsLoading,
  showAlert,
}) => {
  const { ioCredentialId } = useParams();
  const [searchParams, setSearchParams] = useState(initialState);
  const hasSearchParams = Object.values(searchParams).some(
    (value) => value !== undefined
  );

  const handleChange = (key, value) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      [key]: value === "Todos" ? undefined : value,
    }));
  };

  const handleSearch = async () => {
    setIsLoading(true)
    try {
      const { data } = await search(kind, 1, ioCredentialId, searchParams);
      onSearch(data);
    } catch (error) {
      console.log(error);
      showAlert("Erro ao pesquisar.", "error");
    } finally {
      setIsLoading(false)
    }
  };

  const handleClick = () => {
    return hasSearchParams ? handleSearch() : loadData();
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }} mt={1}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <FormControl key="topic-filter" sx={{ flex: 1, mr: 1 }}>
          <InputLabel id="topic-filter-label">Tópico</InputLabel>
          <Select
            labelId="topic-filter-label"
            id="topic-filter"
            value={searchParams.topic || "Todos"}
            variant="standard"
            onChange={({ target }) => handleChange("topic", target.value)}
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {isMappableArray(filters.topics, (option) => (
              <MenuItem key={option[0]} value={option[0]}>
                {option[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl key="status-filter" sx={{ flex: 1, mr: 1 }}>
          <InputLabel id="status-filter-label">Status</InputLabel>
          <Select
            labelId="status-filter-label"
            id="status-filter"
            value={searchParams.status || "Todos"}
            variant="standard"
            onChange={({ target }) => handleChange("status", target.value)}
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {isMappableArray(filters.status, (option) => (
              <MenuItem key={option[0]} value={option[0]}>
                {option[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ flex: 1, mr: 1 }}>
          <TextField
            type="datetime-local"
            label="Data e Hora inicial"
            value={searchParams.start_date}
            variant="standard"
            onChange={({ target }) => handleChange("start_date", target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
        <FormControl sx={{ flex: 1 }}>
          <TextField
            type="datetime-local"
            label="Data e Hora final"
            value={searchParams.end_date}
            variant="standard"
            onChange={({ target }) => handleChange("end_date", target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
      </Box>

      <Box
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          height: 48,
        }}
        mt={2}
        mb={2}
      >
        <TextField
          sx={{ flex: 4, mr: 1 }}
          label="Pesquisa"
          value={searchParams.search}
          variant="standard"
          onChange={({ target }) => handleChange("search", target.value)}
        />

        <Button
          sx={{ height: "100%" }}
          variant="contained"
          color="primary"
          startIcon={<SearchIcon />}
          onClick={handleClick}
        >
          Pesquisar
        </Button>
      </Box>
    </Box>
  );
};

export default withShowAlert(MessageFilter);
